function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import React from 'react';
import PropTypes from 'prop-types';
import isFunction from 'lodash/isFunction';
import { withTheme } from 'styled-components';
import componentPropType from '@signal/prop-types/component';
import renderIf from '@signal/utils/renderIf';
import isValidComponent from '@signal/utils/isValidComponent';
import marginPropType from '../Chart/utils/marginPropType';
import Chart from '../Chart';
export var stackedBarChartSeriesPropType = PropTypes.arrayOf(PropTypes.shape({
  label: PropTypes.string,
  value: PropTypes.number.isRequired,
  fill: PropTypes.oneOfType([PropTypes.string, // theme selectors can be provided as `fill`
  PropTypes.func]).isRequired
}));
export var StackedBarChart = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(StackedBarChart, _React$PureComponent);

  var _super = _createSuper(StackedBarChart);

  function StackedBarChart() {
    _classCallCheck(this, StackedBarChart);

    return _super.apply(this, arguments);
  }

  _createClass(StackedBarChart, [{
    key: "getCumulativeData",
    value:
    /**
     * Calulate the total of all values of series so that the domain can be
     * determined and create an array of ascending values.
     * Ex: an input of a series of the following values [0.5, 0.4, 0.7]
     * would result in a return value of { total: 1.6, xOffsets: [0, 0.5, 0.9] }
     */
    function getCumulativeData() {
      var _this$props = this.props,
          series = _this$props.series,
          getData = _this$props.getData;
      var xOffsets = [];
      var total = series.reduce(function (current, s) {
        xOffsets.push(current);
        return current + getData(s);
      }, 0);
      return {
        xOffsets: xOffsets,
        total: total
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          height = _this$props2.height,
          width = _this$props2.width,
          margin = _this$props2.margin,
          series = _this$props2.series,
          getData = _this$props2.getData,
          getFill = _this$props2.getFill,
          getId = _this$props2.getId,
          pattern = _this$props2.pattern,
          theme = _this$props2.theme;

      var _this$getCumulativeDa = this.getCumulativeData(),
          total = _this$getCumulativeDa.total,
          xOffsets = _this$getCumulativeDa.xOffsets; // TODO: fix this - this is a bad hack because the StackedBarChartWithLegend uses
      // React Resize Observer and it initializes it's children (this chart) with
      // a non-ideal `undefined` height and width. Ideally, we need to refactor this component
      // so that it scales itself. It should probably just be plain CSS.
      // Related to SIG-451


      if (!height || !width) return null;
      return /*#__PURE__*/React.createElement(Chart, {
        height: height,
        width: width,
        margin: margin
      }, renderIf(isValidComponent(pattern), pattern), series.map(function (s, i) {
        var fill = getFill(s); // if `fill` is a function, assume it's a theme selector

        if (isFunction(fill)) fill = fill(theme);
        return /*#__PURE__*/React.createElement("rect", {
          key: getId(s) // x should start where the previous series ended
          ,
          x: xOffsets[i] / total * width,
          y: "0",
          width: getData(s) / total * width,
          height: height,
          fill: fill
        });
      }));
    }
  }]);

  return StackedBarChart;
}(React.PureComponent);

_defineProperty(StackedBarChart, "propTypes", {
  height: PropTypes.number,
  width: PropTypes.number,
  margin: marginPropType,
  series: stackedBarChartSeriesPropType.isRequired,
  getId: PropTypes.func.isRequired,
  getData: PropTypes.func,
  getFill: PropTypes.func,
  pattern: componentPropType
});

_defineProperty(StackedBarChart, "defaultProps", {
  getData: function getData(s) {
    return s.value;
  },
  getFill: function getFill(s) {
    return s.fill;
  },
  pattern: null
});

export default withTheme(StackedBarChart);